import { Game } from "../Game";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { ConnectionManager } from "../ConnectionManager";
import { GameManager } from "../GameManager";
import { SplashState } from "./splash/SplashState";
import { PreLoader } from "./Preloader";

export class Boot extends Phaser.State {

    public static currentInstance: Boot;

    private static bootedInWrongOrientation: boolean;

    public static enterIncorrectOrientation(): void {

        if(GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {

        } else {
            document.getElementById("orientation").style.display = "block";
            document.getElementById("content").style.display = "none";
        }
    }

    public static leaveIncorrectOrientation(): void {

        if(GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {

                Game.currentInstance.time.events.add(250, function (): void {

                    const windowWidth = window.innerWidth;
                    const windowHeight = window.innerHeight;
    
                    GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (windowWidth / windowHeight);

                    if (GameVars.scaleX > 1) {
                        GameVars.scaleX = 1;
                    }
                    
                    if (SplashState.currentInstance) {
                        GameManager.enterSplashScene();
                    } else if(PreLoader.currentInstance) {
                        GameManager.startGame();
                    }
    
                }, this);

        } else {
            document.getElementById("orientation").style.display = "none";
            document.getElementById("content").style.display = "block";

            if (Boot.bootedInWrongOrientation) {

                Boot.bootedInWrongOrientation = false;
    
                Boot.currentInstance.game.time.events.add(250, function (): void {
    
                    const windowWidth = window.innerWidth;
                    const windowHeight = window.innerHeight;
    
                    GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (windowWidth / windowHeight);
    
                    if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIND) {
                        ConnectionManager.init(Boot.currentInstance.game);
                    } else {
                        GameManager.init(Game.currentInstance);
                    }
    
                }, this);
            }
        }
    }

    public static onFullScreenChange(): void {

        Game.currentInstance.time.events.add(100, function (): void {

            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (windowWidth / windowHeight);
            Game.currentInstance.scale.refresh();
        }, Game.currentInstance);
    }

    public static onYandexFullscreenChanged() {

        const aspectRatio = GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH;

        if (Game.currentInstance.device.desktop) {

            let widthLimit = window.innerHeight / aspectRatio;
            const heightLimit = window.innerHeight;

            Game.currentInstance.scale.minWidth = widthLimit;
            Game.currentInstance.scale.minHeight = heightLimit;

            Game.currentInstance.scale.maxWidth = widthLimit;
            Game.currentInstance.scale.maxHeight = heightLimit;

            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (widthLimit / heightLimit);

        } else {

            Game.currentInstance.scale.maxWidth = window.innerWidth;
            Game.currentInstance.scale.maxHeight = Math.max(screen.height, window.innerHeight);
        }

        Game.currentInstance.scale.refresh();
    }

    private static mute(): void {

        Game.currentInstance.sound.mute = true;
    }

    private static unmute(): void {

        if (GameVars.gameData) {
            if (!GameVars.gameData.muted) {
                Game.currentInstance.sound.mute = false;
            }
        }
    }

    public init(): void {

        Boot.currentInstance = this;

        this.input.maxPointers = 2;
        this.game.stage.backgroundColor = "#65AA1F";

        this.game.scale.pageAlignHorizontally = true;
        this.game.scale.pageAlignVertically = true;

        this.game.stage.disableVisibilityChange = true;

        this.game.onBlur.add(Boot.mute, this);
        this.game.onFocus.add(Boot.unmute, this);

        if (this.game.device.desktop) {
            this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
            GameVars.scaleX = 1;
        } else {
            this.game.scale.scaleMode = Phaser.ScaleManager.EXACT_FIT;

            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (windowWidth / windowHeight);
            
            if (windowHeight > windowWidth) {
                GameVars.scaleX = 1;
            }

            if (this.game.scale.compatibility.supportsFullScreen && GameConstants.SPONSOR !== GameConstants.SPONSOR_GAMEPIX && GameConstants.SPONSOR !== GameConstants.SPONSOR_YANDEX) {
                this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.EXACT_FIT;
                this.game.scale.onFullScreenChange.add(Boot.onFullScreenChange, Boot);
            }

            Boot.bootedInWrongOrientation = windowWidth < windowHeight;

            this.game.scale.forceOrientation(true, false);

            this.game.scale.enterIncorrectOrientation.add(Boot.enterIncorrectOrientation, Boot);
            this.game.scale.leaveIncorrectOrientation.add(Boot.leaveIncorrectOrientation, Boot);
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_YANDEX) {
            window.onresize = Boot.onYandexFullscreenChanged;
            Boot.onYandexFullscreenChanged();
        }
    }

    public preload(): void {

        this.load.image("lawn-tile", "assets/lawn_tile.jpg");

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            this.load.image("logo-lagged", "assets/logo-lagged.png");
        }
    }

    public create(): void {

        if(GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {
            GameManager.init(this.game);
        } else {
            if (!Boot.bootedInWrongOrientation) {
                if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIND) {
                    ConnectionManager.init(this.game);
                } else {
                    GameManager.init(this.game);
                }
            }
        }
    }

    public shutdown(): void {

        Boot.currentInstance = null;
        super.shutdown();
    }
}
